import styled from 'styled-components'

import {
  _L_Medium,
  _M_Medium,
  _M_Normal,
  _XL_Bold,
  _XS_Bold,
  Button,
  mainColors,
  Tab,
  TabPanel,
  TabPanels,
  Tabs,
} from '@avantstay/backoffice-core'

export const NotificationWrapper = styled.div`
  position: absolute;
  top: 56px;
  width: 430px;
  height: auto;
  min-height: 200px;
  max-height: 400px;
  background-color: ${mainColors.white};
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 4px;
  box-shadow: 0 -6px 30px 0 rgba(70, 88, 114, 0.1);
  overflow: hidden;
`

export const ModalHeader = styled.div`
  display: grid;
  column-gap: 24px;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  padding: 16px 16px 0;
  height: 56px;
`

export const Title = styled.h1`
  ${_XL_Bold};
  color: ${mainColors.black};
`

export const ReadAllNotificationsButton = styled(Button.Flat)`
  display: flex;
  gap: 6px;

  div {
    position: relative;
  }

  :hover {
    svg {
      color: ${mainColors.accentDark};
    }
  }

  span {
    ${_M_Medium};
  }
`

export const StyledTabs = styled(Tabs)`
  height: 100%;
  max-height: 344px;
  padding: 0;
`

export const StyledTab = styled(Tab)`
  min-width: 53px;
`

export const StyledTabPanels = styled(TabPanels)`
  padding: 16px 8px 24px 16px;
  max-height: 300px;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  mask-image: linear-gradient(to bottom, black calc(100% - 32px), transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black calc(100% - 32px), transparent 100%);

  scrollbar-width: thin;
  scrollbar-color: ${mainColors.neutralDark} transparent;
  &::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }
`

export const StyledTabPanel = styled(TabPanel)`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledDayLabel = styled.label`
  ${_XS_Bold};
  line-height: 18px;
  color: ${mainColors.neutralExtraDark};
  text-transform: uppercase;
  display: block;
`

export const EmptyTitle = styled.h2`
  margin-top: 8px;
  ${_L_Medium};
`

export const EmptyDescription = styled.p`
  ${_M_Normal};
  color: ${mainColors.neutralExtremelyDark};
  margin-bottom: 24px;
`
